<template>
  <div>
    <!-- eslint-disable -->
    <v-dialog
      v-model="viewFootfolderDetails"
      max-width="500px"
      transition="dialog-top-transition"
    >
      <v-card>
        <v-toolbar elevation="0" dark dense class="navBar">
          <v-toolbar-title class="custom-title">File Details</v-toolbar-title>
          <v-spacer />
          <v-icon class="icon-class" @click="closeDialog()">mdi-close</v-icon>
        </v-toolbar>
        <v-card-text>
          <v-overlay :value="loading">
            <v-progress-circular
              indeterminate
              class="icon-class"
              size="44"
            ></v-progress-circular>
          </v-overlay>
          <div>
            <v-row class="justify-center">
              <iframe
                :src="FileUrl"
                width="100%"
                v-if="fileType == 'Image'"
                height="500px"
                allowfullscreen
                class="mt-10 justify-center"
                frameborder="0"
              ></iframe>
              <video
                v-else
                controls
                class="pt-4"
                :src="FileUrl"
                style="max-height: 500px; max-width: 300px"
              />
            </v-row>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
/* eslint-disable */

export default {
  props: {
    cabinetInfo: String,
    fileType: String,
    viewFootfolderDetails: Boolean,
  },

  data() {
    return {
      FileUrl: "",
      loading: false,
    };
  },
  watch: {
    viewFootfolderDetails: {
      async handler() {
        if (this.viewFootfolderDetails == true) {
          this.FileUrl = "";
          this.FileUrl = this.cabinetInfo;
          // console.log(this.cabinetInfo, "rowInfo");
        }
      },

      immediate: true,
    },
  },
  // watch: {
  //     viewFootfolderDetails(newVal) {
  //         if (newVal) {
  //             const data = this.$store.getters.GetUserObj;
  //             this.get_fileurl(data);
  //         } else {
  //             this.FileUrl = '';
  //             this.loading = false;
  //         }
  //     },
  // },
  methods: {
    closeDialog() {
      this.FileUrl = "";
      this.loading = false;
      this.$emit("clicked", 0);
    },
  },
};
</script>
<style scoped>
.navBar {
  background-color: #3f51b5;
}
.iframe-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 500px;
  overflow: hidden;
  background-color: #f5f5f5;
}
</style>
